import type { InputProps } from '@cvo/ui/components';

/**
 * Month/Year Formatter Model
 *
 * Constants, interfaces, and validation error keys for month/year input formatting.
 */

// ============================================================================
// Configuration Object
// ============================================================================

/**
 * Centralized configuration for Month/Year input formatting
 */
export const MONTH_YEAR_CONFIG = {
  /** Separator with spaces on both sides */
  separator: ' / ',

  /** Month position in formatted string (0-1) */
  monthLength: 2,

  /** Month range constants */
  minMonth: 1,
  maxMonth: 12,

  /** Year range constants */
  minYear: 1900,
  maxYear: 2200,
} as const;

// ============================================================================
// Types
// ============================================================================

/**
 * Year format type for MonthYearInput
 * - 'YY': Short year format (e.g., "01 / 25")
 * - 'YYYY': Full year format (e.g., "01 / 2025")
 */
export type YearFormat = 'YY' | 'YYYY';

// ============================================================================
// Interfaces
// ============================================================================

/**
 * Parsed month/year value
 */
export interface MonthYearValue {
  /** Month as two-digit string (01-12) */
  month: string;
  /** Year as four-digit string (e.g., "2030") */
  year: string;
}

/**
 * Props for MonthYearInput component
 * Extends InputProps with type='text' for credit card expiration date input
 */
export interface MonthYearInputProps extends InputProps {
  /** Placeholder text for the input field */
  placeholder?: string;
  /** Year format: 'YY' for short or 'YYYY' for full (default: 'YYYY') */
  yearFormat?: YearFormat;
}
